<template>
  <div v-if="visibleNoNews && !visible">
    <div class="homepage-main-container homepage-main" style="min-height: 400px; padding-top: 40px">
      <span>Er is geen nieuws gevonden voor de beschikbare Hubspot
        Accounts</span>
    </div>
  </div>
  <div v-if="!visible && !visibleNoNews">
    <div class="homepage-main-container homepage-main" style="min-height: 400px; padding-top: 40px">
      <span>{{ statusText }}</span>
    </div>
  </div>
  <div v-if="visible">
    <div class="news-select-page">
      <div class="page-top">
        <!--     <div class="logo-container row justify-end">
        <img
          class="logo"
          src="https://www.vindsubsidies.nl/frontend/assets/static/logo.svg"
        />
      </div> -->
        <p class="page-intro row" v-if="isNewsSelect">
          Gebaseerd op het profiel van deze klant, zijn er
          {{ currentNewsOptions.length }} nieuwsberichten klaargezet
        </p>
        <p class="page-intro row" v-else>
          Gebaseerd op het profiel van deze klant, zijn er
          {{ currentSchemesOptions.length }} regelingen klaargezet
        </p>
      </div>
    </div>

    <!-- Select news items per customer -->
    <div class="news-select customers-select">
      <NewsDialogPerCustomer />

      <div class="select-page-top">
        <div class="row justify-between fixed-width">
          <div class="column">
            <h3 class="page-heading row">
              {{ currentSalesForceCustomer.name }}
            </h3>
            <div class="page-sub" v-if="isNewsSelect">
              Selecteer de nieuwsberichten voor deze klant
            </div>
            <div class="page-sub" v-else>
              Selecteer de regelingen voor deze klant
            </div>
          </div>

          <div class="counter" v-if="salesForceCustomersCount - currentCustomersIndex - 1 > 1">
            Nog
            {{ salesForceCustomersCount - currentCustomersIndex - 1 }} klanten
            te gaan
          </div>
          <div class="counter" v-else-if="
            salesForceCustomersCount - currentCustomersIndex - 1 == 1
          ">
            Nog {{ salesForceCustomersCount - currentCustomersIndex - 1 }} klant
            te gaan
          </div>
          <div class="counter" v-else>Dit is de laatste</div>
        </div>
      </div>

      <div class="column">
        <div class="row justify-between">
          <div class="column">
            <q-btn-group class="btn-group" outline>
              <q-btn no-caps class="orange-btn-filled" @click="updateIsNewsSelect(true)" label="Nieuws" />
              <q-btn no-caps class="orange-btn-filled" label="Regelingen" @click="updateIsNewsSelect(false)" />
            </q-btn-group>

            <q-btn-group class="btn-group" outline>
              <q-btn no-caps class="btn-vind-dark" @click="isNewsSelect ? selectAllNews() : selectAllSchemes()"
                label="Selecteer alles" />
              <q-btn no-caps class="btn-vind-dark" label="Deselecteer alles"
                @click="isNewsSelect ? deselectAllNews() : deselectAllSchemes()" />
            </q-btn-group>
          </div>

          <q-btn-group v-if="currentCustomersIndex == salesForceCustomersCount - 1" class="btn-group"
            style="height: 38px">
            <q-btn no-caps class="btn-vind-dark" label="Vorige item" @click="decreaseCustomersIndex()"
              :disable="currentCustomersIndex == 0 ? true : false" />
            <q-btn no-caps class="btn-vind-dark" label="Finish" @click="goToFinishPageCustomers()" />
          </q-btn-group>
          <q-btn-group v-else outline class="btn-group">
            <q-btn no-caps class="btn-vind-dark" label="Vorige item" @click="decreaseCustomersIndex()"
              :disable="currentCustomersIndex == 0 ? true : false" />
            <q-btn no-caps class="btn-vind-dark" label="Volgende item" @click="increaseCustomersIndex()" :disable="currentCustomersIndex == salesForceCustomersCount - 1
              ? true
              : false
              " />
          </q-btn-group>
        </div>
        <div class="container-customers-box" v-if="isNewsSelect">
          <div class="customers-box">
            <q-item-label class="list-header row" header>Nieuws titel</q-item-label>
            <q-tree :nodes="currentNewsOptions" v-model:ticked="tickedNews" node-key="id" tick-strategy="strict"
              default-expand-all v-model:selected="selectedNews" @update:selected="showNewsDetails()" />
          </div>
        </div>

        <div class="container-customers-box" v-else>
          <div class="customers-box">
            <q-item-label class="list-header row" header>Scheme titel</q-item-label>
            <q-tree :nodes="currentSchemesOptions" v-model:ticked="tickedSchemes" node-key="id" tick-strategy="strict"
              default-expand-all v-model:selected="selectedSchemes" @update:selected="showSchemeDetails()" />
          </div>
        </div>
      </div>

      <div class="next-item-group row"></div>
    </div>
  </div>
  <SchemeDialog />

  <NewsDialog />
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import store from "../store/index";
import NewsDialog from "../components/news-select-components/NewsDialog.vue";
import { useRouter } from "vue-router";
import NewsDialogPerCustomer from "../components/news-select-components/NewsDialogPerCustomer.vue";
import hubSpotService from "../services/hubSpotService";
import SchemeDialog from "../components/news-select-components/SchemeDialog.vue";
export default {
  name: "NewsSelectPageHubspot",
  components: {
    NewsDialog,
    NewsDialogPerCustomer,
    SchemeDialog,
  },
  setup() {
    onMounted(async () => {
      hubSpotService
        .getAccountsHubSpot()
        .then(() => {
          for (
            let i = 0;
            i < store.state.salesForce.selectedNewsForCurrentCustomer.length;
            i++
          ) {
            tickedNews.value.push(
              store.state.salesForce.selectedNewsForCurrentCustomer[i]
            );
          }
          for (
            let i = 0;
            i < store.state.salesForce.selectedSchemesForCurrentCustomer.length;
            i++
          ) {
            tickedSchemes.value.push(
              store.state.salesForce.selectedSchemesForCurrentCustomer[i]
            );
          }
          if (
            store.state.salesForce.accountsList.length != null &&
            store.state.salesForce.accountsList.length > 0
          )
            visible.value = true;
          else visibleNoNews.value = true;
        })
        .catch((e) => {
          router.push({
            name: "ErrorPage",
          });
        });
    });

    // This part is for selecting customers per news item
    const currentNewsItem = computed({
      get: () => store.state.salesForce.currentNewsItem,
    });
    const currentIndex = computed({
      get: () => store.state.salesForce.currentIndex,
    });

    const isNewsSelectPage = computed({
      get: () => store.state.newsSelect.isNewsSelectPage,
    });
    const itemsCount = computed({
      get: () => store.state.salesForce.newsItemsCount,
    });
    const decreaseIndex = () => {
      store.commit("salesForce/updateCustomersForNewsItem", ticked.value);
      store.commit("salesForce/decreaseIndex");
      ticked.value = [];
    };

    const increaseIndex = () => {
      store.commit("salesForce/updateCustomersForNewsItem", ticked.value);
      store.commit("salesForce/increaseIndex");
      ticked.value = [];
    };

    const enableNewsDialog = () => {
      store.commit("salesForce/enableNewsModal");
    };
    const enableSchemeDialog = () => {
      store.commit("salesForce/enableSchemeDialog");
    };
    const router = useRouter();

    const goToFinishPage = () => {
      store.commit("salesForce/updateCustomersForNewsItem", ticked.value);
      ticked.value = [];

      store.commit("salesForce/setIndex", 0);
      router.push({
        name: "NewsSelectFinal",
      });
    };

    const customerTags = computed({
      get: () => store.state.salesForce.accountsList.customerTags,
    });

    const customersList = computed({
      get: () => store.state.salesForce.customersList,
    });

    const ticked = ref([]);
    const visible = ref(false);
    const visibleNoNews = ref(false);
    const statusText = ref("Hubspot gegevens ophalen");

    const deselectAll = () => {
      ticked.value = [];
    };

    const selectAll = () => {
      for (let i = 0; i < customersList.value.length; i++)
        ticked.value.push(customersList.value[i].id);
    };

    // This part is for selecting news items per customer
    const tickedNews = ref([]);
    const tickedSchemes = ref([]);

    const accountsList = computed({
      get: () => store.state.salesForce.accountsList,
    });

    const salesForceCustomersList = computed({
      get: () => store.state.salesForce.salesForceCustomersList,
    });

    const salesForceCustomersCount = computed({
      get: () => store.state.salesForce.salesForceCustomersCount,
    });

    const currentSalesForceCustomer = computed({
      get: () => store.state.salesForce.currentSalesForceCustomer,
    });

    const currentCustomersIndex = computed({
      get: () => store.state.salesForce.currentCustomersIndex,
    });

    const serverData = computed({
      get: () => store.state.salesForce.newsItemsPerCustomerListForServer,
    });

    const serverDataSchemes = computed({
      get: () => store.state.salesFroce.schemeItemsPerCustomerListForServer,
    });

    const decreaseCustomersIndex = () => {
      store.commit("salesForce/updateNewsForCustomer", tickedNews.value);

      store.commit("salesForce/decreaseCustomerIndex");
      store.commit("salesForce/updateNewsForCurrentCustomer");
      tickedNews.value = store.state.salesForce.selectedNewsForCurrentCustomer;
      tickedSchemes.value =
        store.state.salesForce.selectedSchemesForCurrentCustomer;
      store.commit("salesForce/createNewsItemsPerCustomerListForServer");
      store.commit("salesForce/createSchemeItemsPerCustomerListForServer");
      hubSpotService.postNewsSelection(
        serverData.value,
        serverDataSchemes.value
      );
    };

    const increaseCustomersIndex = () => {
      store.commit("salesForce/updateNewsForCustomer", tickedNews.value);

      store.commit("salesForce/increaseCustomerIndex");
      store.commit("salesForce/updateNewsForCurrentCustomer");
      tickedNews.value = store.state.salesForce.selectedNewsForCurrentCustomer;
      tickedSchemes.value =
        store.state.salesForce.selectedSchemesForCurrentCustomer;
      store.commit("salesForce/createNewsItemsPerCustomerListForServer");
      store.commit("salesForce/createSchemeItemsPerCustomerListForServer");
      hubSpotService.postNewsSelection(
        serverData.value,
        serverDataSchemes.value
      );
    };

    const currentNewsOptions = computed({
      get: () => store.state.salesForce.currentNewsOptions,
    });

    const currentSchemesOptions = computed({
      get: () => store.state.salesForce.currentSchemesOptions,
    });

    const deselectAllNews = () => {
      tickedNews.value = [];
    };

    const deselectAllSchemes = () => {
      tickedSchemes.value = [];
    };

    const selectAllNews = () => {
      for (let i = 0; i < currentNewsOptions.value.length; i++)
        tickedNews.value.push(currentNewsOptions.value[i].id);
    };

    const selectAllSchemes = () => {
      for (let i = 0; i < currentSchemesOptions.value.length; i++)
        tickedSchemes.value.push(currentSchemesOptions.value[i].id);
    };

    const selectedNewsPerCustomer = computed({
      get: () => store.state.salesForce.selectedNewsPerCustomer,
    });

    const goToFinishPageCustomers = () => {
      store.commit("salesForce/updateNewsForCustomer", tickedNews.value);
      store.commit("salesForce/updateSchemesForCustomer", tickedSchemes.value);
      store.commit("salesForce/setCustomersIndex", 0);
      store.commit("salesForce/createNewsItemsPerCustomerListForServer");
      store.commit("salesForce/createSchemeItemsPerCustomerListForServer");
      router.push({
        name: "NewsForCustomersFinal",
      });
    };

    const showNewsDetails = () => {
      if (selectedNews.value != null) {
        store.commit(
          "salesForce/updateCurrentNewsItemPerCustomer",
          selectedNews.value
        );
        store.commit("salesForce/enableNewsModalPerCustomer");
      }
    };

    const showSchemeDetails = () => {
      if (selectedSchemes.value != null) {
        store.commit(
          "salesForce/updateCurrentSchemeItemPerCustomer",
          selectedSchemes.value
        );
        store.commit("salesForce/enableSchemeModal");
      }
    };

    const selectedNews = ref(null);
    const selectedSchemes = ref(null);

    watch(
      () => selectedNews.value,
      async (next, prev) => {
        if (prev && prev != null && next == null) {
          store.commit("salesForce/updateCurrentNewsItemPerCustomer", prev);
          store.commit("salesForce/enableNewsModalPerCustomer");
        }
      }
    );

    watch(
      () => selectedSchemes.value,
      async (next, prev) => {
        if (prev && prev != null && next == null) {
          store.commit("salesForce/updateCurrentSchemeItemPerCustomer", prev);
          store.commit("salesForce/enableSchemeModal");
        }
      }
    );

    const isNewsSelect = ref(true);
    const updateIsNewsSelect = (val) => {
      isNewsSelect.value = val;
    };

    return {
      showSchemeDetails,
      serverDataSchemes,
      tickedSchemes,
      selectAllSchemes,
      deselectAllSchemes,
      currentSchemesOptions,
      isNewsSelect,
      updateIsNewsSelect,
      // Select news items per customer
      selectedNews,
      selectedSchemes,
      showNewsDetails,
      goToFinishPageCustomers,
      selectedNewsPerCustomer,
      accountsList,
      salesForceCustomersList,
      salesForceCustomersCount,
      currentSalesForceCustomer,
      currentCustomersIndex,
      increaseCustomersIndex,
      decreaseCustomersIndex,
      currentNewsOptions,
      tickedNews,
      selectAllNews,
      deselectAllNews,
      // Select customers per news item
      selectAll,
      deselectAll,
      ticked,
      customersList,
      customerTags,
      goToFinishPage,
      enableNewsDialog,
      enableSchemeDialog,
      increaseIndex,
      decreaseIndex,
      currentNewsItem,
      currentIndex,
      itemsCount,
      isNewsSelectPage,
      visible,
      visibleNoNews,
      statusText,
    };
  },
};
</script>
